import React from 'react';
import Tooltip from '../../../../CommonComponents/UIComponents/ToolTip/Tooltip';
import OverlayTrigger from '../../../../CommonComponents/UIComponents/OverlayTrigger/OverlayTrigger';
import CommonLoader from '../../Common/Loader';
import Dropdown from '../../Common/Dropdown';
import './EnterPrescription.scss';

const handleProductList = props => {
  const { productCallsAction, updatePowerErrorList, clOpenList, isJitProduct } = props;
  if (!isJitProduct && typeof updatePowerErrorList === 'function') {
    updatePowerErrorList(clOpenList);
  }
  productCallsAction.handleClDropdownOpenList('');
};

const openDropdown = (props, data) => {
  const { productCallsAction } = props;
  productCallsAction.handleClDropdownOpenList(data);
};

const EnterPrescription = props => {
  const {
    localeInfo,
    dataLocale,
    errPowerList,
    isContactPrescription,
    productId,
    contactLensData,
    addToCart,
    isContactPrescValid,
    loadingContactPackage,
    rightBoxValue,
    rightBoxChange,
    rightBox,
    leftBox,
    leftPowers,
    rightPowers,
    stateKey,
    clOpenList,
    leftBoxValue,
    leftBoxChange,
    BoxedValue,
    checkboxToggle,
    toggleChecked,
    setName,
    setDOB,
    setNotes,
    genderValueUpdate,
    userNameError,
    selectedPowerFromUrl,
    isJitProduct,
    isNonJitPowerValidated,
    contactLensId,
  } = props;
  const {
    INVALID_POWERS_NOT_APPLICABLE,
    PRESCRIPTION_FROM_YOUR_DOCTOR,
    NOTE,
    CL_POWER_CAN_BE_DIFFERENT,
    HOW_TO_READ_YOUR_PRESCRIPTION,
    OD_RIGHT_EYE,
    OD_LEFT_EYE,
    TO_LEARN_MORE,
    SIX_LENS_PER_BOX_FOR_1_EYE,
    PLEASE_SELECT,
    I_DONT_KNOW_MY_POWER,
    NUMBER_OF_BOXES_CAN_NOT_BE,
    FEMALE,
    MALE,
    GENDER,
    OPTIONAL,
    ALL_POWER_FIELDS_ARE_MANDATORY,
    CANT_FIND_YOUR_POWER_CALL,
    CONVERT_EYEGLASSES_POWER,
    USERS_NAME,
    THIS_IS_YOUR_MAIN_POWER,
    ADDITIONAL_NOTES,
    NOT_ALL_POWERS_HAVE_CYLINDER,
    SAVE_AND_CONTINUE,
    BOX,
    CLICK_HERE,
    ONLY_IF_YOU_HAVE_CYL,
    ONLY_ALPHABETS_AND_SPACE_ALLOWED,
    DOB,
  } = dataLocale;
  const { domainUrl } = localeInfo;
  return (
    <form onSubmit={ev => addToCart(ev, contactLensId)}>
      <div className="clEnterPresTab col-lg-12 col-md-12 col-sm-12 no-padding">
        <div className="col-lg-12 col-md-12 col-sm-12">
          {!isContactPrescValid && isJitProduct && (
            <div className="alert alert-danger">{INVALID_POWERS_NOT_APPLICABLE}</div>
          )}
          {!isContactPrescValid && !isJitProduct && isNonJitPowerValidated && (
            <div className="alert alert-danger">{`${isContactPrescription.message}`}</div>
          )}
          <p style={{ paddingRight: '30px' }}>{PRESCRIPTION_FROM_YOUR_DOCTOR}</p>
          <p>
            <strong>{NOTE}:</strong> {CL_POWER_CAN_BE_DIFFERENT}{' '}
          </p>
        </div>
        <div className="clearfix"></div>
        <div className="col-lg-12 col-md-12 col-sm-12 contact-read-learn">
          {loadingContactPackage && (
            <div className="contact-loader">
              <CommonLoader />
            </div>
          )}
          <a
            href={`//${domainUrl}/understand-your-prescription.html`}
            rel="noopener noreferrer"
            style={{ float: 'left' }}
            target="_blank"
          >
            {HOW_TO_READ_YOUR_PRESCRIPTION}
          </a>
          <a
            href={`//${domainUrl}/convert-your-eyeglasses-power.html`}
            rel="noopener noreferrer"
            style={{ float: 'right' }}
            target="_blank"
          >
            {CONVERT_EYEGLASSES_POWER}
          </a>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t10 margin-b10">
          <div className="col-lg-2 col-md-2 col-sm-2 padding-r0 padding-l5 contact-type-option">
            {OD_RIGHT_EYE}
          </div>
          {contactLensData &&
            contactLensData.powerTypeList &&
            contactLensData?.powerTypeList?.map((data, index) => {
              return (
                <div key={index} className="col-lg-2 col-md-2 col-sm-2 padding-r0 padding-l5">
                  <div className="contact-type-lens">
                    {data.label}
                    <OverlayTrigger
                      delayHide={1000}
                      overlay={
                        <Tooltip id={data.type} title={data.type}>
                          {data.type === 'boxes' && (
                            <div>
                              {SIX_LENS_PER_BOX_FOR_1_EYE}. {TO_LEARN_MORE},{' '}
                              <a
                                className="text-lowercase"
                                href={`//${domainUrl}/understanding_lens`}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                {CLICK_HERE}.
                              </a>
                            </div>
                          )}
                          {data.type === 'sph' && (
                            <div>
                              {THIS_IS_YOUR_MAIN_POWER}. {TO_LEARN_MORE}{' '}
                              <a
                                className="text-lowercase"
                                href={`//${domainUrl}/understand-your-prescription.html`}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                {CLICK_HERE}.
                              </a>
                            </div>
                          )}
                          {data.type === 'cyl' && (
                            <div>
                              {NOT_ALL_POWERS_HAVE_CYLINDER}. {TO_LEARN_MORE}{' '}
                              <a
                                className="text-lowercase"
                                href={`//${domainUrl}/understand-your-prescription.html`}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                {CLICK_HERE}.
                              </a>
                            </div>
                          )}
                          {data.type === 'axis' && (
                            <div>
                              {ONLY_IF_YOU_HAVE_CYL}. {TO_LEARN_MORE}{' '}
                              <a
                                className="text-lowercase"
                                href={`//${domainUrl}/understand-your-prescription.html`}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                {CLICK_HERE}.
                              </a>
                            </div>
                          )}
                        </Tooltip>
                      }
                      placement="top"
                      trigger={['hover', 'focus']}
                    >
                      <div className="power_overlay">
                        <span className="power_overlay_tigger">?</span>
                      </div>
                    </OverlayTrigger>
                  </div>
                  {index === 0 ? (
                    <div className="select-style">
                      <select
                        ref={powerOptionBoxRight => {
                          rightBox[data.type] = powerOptionBoxRight;
                        }}
                        name={data.type}
                        value={rightBoxValue}
                        onChange={ev => rightBoxChange(ev)}
                      >
                        {data.powerDataList.map(mydata => {
                          return Object.keys(mydata.value).map(key => {
                            return (
                              <option key={key} value={mydata.value[key]}>
                                {' '}
                                {`${mydata.value[key]} ${BOX}`}
                              </option>
                            );
                          });
                        })}
                      </select>
                    </div>
                  ) : (
                    <Dropdown
                      errPowerList={errPowerList}
                      isDisabled={rightBoxValue}
                      name={data.type}
                      openList={clOpenList}
                      openedPowerTab={stateKey}
                      power="right-power"
                      {...props}
                      ref={powerOptionValueRight => {
                        rightPowers[data.type] = powerOptionValueRight;
                      }}
                      defaultLabel={PLEASE_SELECT}
                      handleProductList={handleProductList}
                      list={data.powerDataList[0].value}
                      openDropdown={openDropdown}
                      selectedPowerFromUrl={selectedPowerFromUrl}
                    />
                  )}
                </div>
              );
            })}
          {!isJitProduct &&
            !isContactPrescValid &&
            !isNonJitPowerValidated &&
            isContactPrescription.result[0].rightQuantityValidationError && (
              <div className="col-lg-10 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-2 col-sm-offset-2 padding-t5 padding-l5 text-red">{`${isContactPrescription.result[0].rightQuantityValidationError}`}</div>
            )}
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t10 margin-b10">
          <div className="col-lg-2 col-md-2 col-sm-2 padding-r0 padding-l5 contact-type-option-left">
            {OD_LEFT_EYE}
          </div>
          {contactLensData && contactLensData.powerTypeList &&
            contactLensData?.powerTypeList?.map((data, index) => {
              return (
                <div key={index} className="col-lg-2 col-md-2 col-sm-2 padding-r0 padding-l5">
                  {index === 0 ? (
                    <div className="select-style">
                      {' '}
                      <select
                        ref={powerOptionBoxLeft => {
                          leftBox[data.type] = powerOptionBoxLeft;
                        }}
                        name={data.type}
                        value={leftBoxValue}
                        onChange={ev => leftBoxChange(ev)}
                      >
                        {data.powerDataList[0].value[0] === '1' && (
                          <option value="0">0 {BOX}</option>
                        )}
                        {data.powerDataList.map(mydata => {
                          return Object.keys(mydata.value).map(key => {
                            return (
                              <option key={key} value={mydata.value[key]}>
                                {`${mydata.value[key]} ${BOX}`}
                              </option>
                            );
                          });
                        })}
                      </select>
                    </div>
                  ) : (
                    <Dropdown
                      ref={powerOptionValueLeft => {
                        leftPowers[data.type] = powerOptionValueLeft;
                      }}
                      isDisabled={leftBoxValue}
                      name={data.type}
                      openList={clOpenList}
                      openedPowerTab={stateKey}
                      power="left-power"
                      {...props}
                      defaultLabel={PLEASE_SELECT}
                      handleProductList={handleProductList}
                      list={data.powerDataList[0].value}
                      openDropdown={openDropdown}
                    />
                  )}
                </div>
              );
            })}
          {!isJitProduct &&
            !isContactPrescValid &&
            !isNonJitPowerValidated &&
            isContactPrescription.result[0].leftQuantityValidationError && (
              <div className="col-lg-10 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-2 col-sm-offset-2 padding-t5 padding-l5 text-red">{`${isContactPrescription.result[0].leftQuantityValidationError}`}</div>
            )}
        </div>
        {!isJitProduct && errPowerList?.length > 0 && (
          <div className="col-lg-10 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-2 col-sm-offset-2 padding-b10 padding-l5 text-red">
            {ALL_POWER_FIELDS_ARE_MANDATORY}.
          </div>
        )}
        <div
          className={`${BoxedValue} col-lg-10 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-2 col-sm-offset-2 padding-b10 padding-l5 text-red`}
        >
          {NUMBER_OF_BOXES_CAN_NOT_BE}
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 no-padding dont-power layout center">
          <div className="col-lg-offset-2 col-md-offset-2 col-sm-offset-2 padding-l5">
            <div className="control-group">
              <label className="control control--checkbox">
                {I_DONT_KNOW_MY_POWER}
                <input
                  checked={toggleChecked}
                  type="checkbox"
                  onChange={e => checkboxToggle(e, contactLensId)}
                />
                <div className="control__indicator"></div>
              </label>
            </div>
          </div>
          <div className="font-bold margin-l20">{CANT_FIND_YOUR_POWER_CALL}</div>
        </div>
        <div className="col-lg-12 col-md-12 no-padding margin-t20 no-padding">
          <div className="col-lg-12 col-md-12 no-padding">
            <div className="form-group col-lg-6 col-md-6">
              <label className="col-2 col-form-label" htmlFor="example-text-input">
                {USERS_NAME}
              </label>
              <div className="col-10">
                <input
                  ref={textFirstName => setName(textFirstName)}
                  className="form-control"
                  id="example-text-input"
                  type="text"
                />
                <div className={userNameError} style={{ color: 'red' }}>
                  {ONLY_ALPHABETS_AND_SPACE_ALLOWED}
                </div>
              </div>
            </div>
            <div className="form-group col-lg-6 col-md-6">
              <label className="col-2 col-form-label" htmlFor="example-search-input">
                {DOB} <span className="faded-text">({OPTIONAL})</span>
              </label>
              <input
                ref={textDob => setDOB(textDob)}
                className="form-control"
                id="example-search-input"
                placeholder="DD-MM-YYYY"
                type="search"
              />
            </div>
          </div>
          <div className="col-lg-12 col-md-12 no-padding">
            <div className="form-group col-lg-6 col-md-6">
              <label className="col-2 col-form-label" htmlFor="example-url-input">
                {GENDER} <span className="faded-text">({OPTIONAL})</span>
              </label>
              <div className="col-10">
                <div className="radiobtn">
                  <label className="pull-left">
                    <input
                      name="gender"
                      type="radio"
                      value={MALE}
                      onChange={ev => genderValueUpdate(ev)}
                    />
                    <span>{MALE}</span>
                  </label>
                  <label>
                    <input
                      className="pull-right"
                      name="gender"
                      type="radio"
                      value={FEMALE}
                      onChange={ev => genderValueUpdate(ev)}
                    />
                    <span>{FEMALE}</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="form-group col-lg-6 col-md-6">
              <label className="col-2 col-form-label" htmlFor="example-email-input">
                {ADDITIONAL_NOTES} <span className="faded-text">({OPTIONAL})</span>
              </label>
              <div className="col-10">
                <input
                  ref={textNotes => setNotes(textNotes)}
                  className="form-control"
                  id="example-tel-input"
                  type="tel"
                />
              </div>
            </div>
          </div>
        </div>
        <button
          className="submit-btn submit-btn pull-right margin-r10 margin-b10 text-uppercase"
          type="submit"
          unbxdattr="AddToCart"
          unbxdparam_sku={productId}
        >
          {SAVE_AND_CONTINUE}
        </button>
      </div>
    </form>
  );
};

export default EnterPrescription;
